export const GET_LIST_REPORTS_ORDERS = 'providers/reports/Orders/GET_LIST_REPORTS_ORDERS';
export const GET_DETAILS_REPORTS_ORDERS = 'providers/reports/Orders/GET_DETAILS_REPORTS_ORDERS';
export const GET_LIST_REPORTS_ORDERS_SCROLL_PAGINATION =
  'providers/reports/Orders/GET_LIST_REPORTS_ORDERS_SCROLL_PAGINATION';
export const EXPORT_REPORTS_ORDERS = 'providers/reports/Orders/EXPORT_REPORTS_ORDERS';
